export default __webpack_public_path__ + "app/images/btn-toolbar-zoom-out-normal.svg";